import { useApiQuery } from '../../hooks/query';
import {
  DEVICE_MODELS_API_URL,
  deviceModelsQueryKeys,
} from './device-models.constants';
import { DeviceModelType } from './device-models.types';

export function useDeviceModels() {
  return useApiQuery<Array<DeviceModelType>>(
    DEVICE_MODELS_API_URL,
    deviceModelsQueryKeys.base
  );
}
